<ng-container [ngPlural]="amount">
  <ng-template ngPluralCase="=1">
    {{ singleKey | translate:params }}
  </ng-template>
  <ng-template ngPluralCase="other">
    {{ multiKey | translate:params }}
  </ng-template>
</ng-container>
